var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"drill-report-no-video-text-comp"},[_c('p',[_vm._v("检测到设备性能不稳定")]),_c('p',[_vm._v("已自动关闭视频生成功能")])])
}]

export { render, staticRenderFns }